<template>
  <div class="shenyunjie-chart-simple" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import merge from "deepmerge";

export default {
  name: "YunJieChartSimple",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    xData: {
      type: Array,
      default: function () {
        return [];
      }
    },
    xType: {
      type: String,
      default: "category"
    },
    yData: {
      type: Array,
      default: function () {
        return [];
      }
    },
    yType: {
      type: String,
      default: "line"
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      defaultOption: {
        title: {
          left: "center"
        },
        yAxis: {
          type: "value"
        }
      },
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizeSimple);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizeSimple() {
      let self = this;
      if (self.chart) {
        self.chart.resize();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        if (!self.chart) {
          let theme = self.theme || (this.$YunJie || {}).theme || "standard";
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark");
          } else {
            self.chart = echarts.init(document.getElementById(self.id));
          }
        }
        // 配置汇总
        let parameter = {
          title: {
            text: self.title
          },
          xAxis: {
            type: self.xType,
            data: self.xData,
            axisLabel: {
              formatter: self.xType == "time" ? "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}" : "{value}"
            }
          },
          series: [{
            data: self.yData,
            type: self.yType
          }],
          tooltip: {
            show: self.tooltip,
            trigger: "axis"
          }
        };
        let opt = merge(self.defaultOption, parameter);
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeSimple);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    xData: {
      deep: true,
      handler(xData) {
        this.init();
      }
    },
    xType() {
      this.init();
    },
    yData: {
      deep: true,
      handler(yData) {
        this.init();
      }
    },
    yType() {
      this.init();
    },
    tooltip() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-simple {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/simple.vue